import { AdvisorLayerMode } from '../enums/advisorLayerMode'
import { isAdvisorLayerMode } from './isAdvisorLayerMode'

export const ADVISOR_LAYER_QUERY_PARAM = 'advisorLayer'

export const getModeFromSearch = (search: string): AdvisorLayerMode | undefined => {
  const params = new URLSearchParams(search)
  const value = params.get(ADVISOR_LAYER_QUERY_PARAM)
  return isAdvisorLayerMode(value) ? value : undefined
}

export const buildSearchWithMode = (search: string, mode: AdvisorLayerMode): string => {
  const params = new URLSearchParams(search)
  params.set(ADVISOR_LAYER_QUERY_PARAM, mode)
  return params.toString()
}
